import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandTakeTemplatePage } from './cabsand-take-template';

@NgModule({
  declarations: [
    CabsandTakeTemplatePage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandTakeTemplatePage),
  ],
})
export class CabsandTakeTemplatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-take-template/cabsand-take-template.module.ts